import { promptCommissionRegeneration } from "../components/commissionRegenerationPrompt";
import {
  getCommissionAffectingChanges,
  pickCommissionAffectingSnapshot,
} from "./commissionOrderChangeUtils";

export async function applyCommissionRegenerationPrompt({
  values,
  baseline,
}) {
  const payload = { ...values };

  if (!payload.commissionSetting || !baseline) {
    return { payload, cancelled: false };
  }

  const changes = getCommissionAffectingChanges(
    baseline,
    pickCommissionAffectingSnapshot(payload)
  );

  if (changes.length === 0) {
    return { payload, cancelled: false };
  }

  const choice = await promptCommissionRegeneration(changes);
  if (choice === "cancel") {
    return { payload, cancelled: true };
  }
  if (choice === "skip") {
    payload.skipUpdateCommissionSetting = true;
  }

  return { payload, cancelled: false };
}
